import LegalPage from "../components/LegalPage";
import { PRIVACY } from "../content/legal";

export default function Privacy() {
  return <LegalPage title="Privacy Policy" source={PRIVACY} />;
}
